var map = {
	"./currencies/Cleo.svg": [
		77589,
		7589
	],
	"./flags/GB.svg": [
		44102,
		4102
	],
	"./flags/JP.svg": [
		92444,
		2444
	],
	"./flags/SP.svg": [
		34293,
		4293
	],
	"./flags/TH.svg": [
		66799,
		6799
	],
	"./flags/UA.svg": [
		93821,
		3821
	],
	"./other/3dcube.svg": [
		20371,
		371
	],
	"./other/Account.svg": [
		44277,
		4277
	],
	"./other/Bonus.svg": [
		67631,
		7631
	],
	"./other/Budget.svg": [
		38254,
		8254
	],
	"./other/Business.svg": [
		60028,
		28
	],
	"./other/Calendar.svg": [
		96313,
		6313
	],
	"./other/CalendarBicolor.svg": [
		23850,
		3850
	],
	"./other/CategoryBicolor.svg": [
		28409,
		8409
	],
	"./other/Chart.svg": [
		79143,
		9143
	],
	"./other/Collections.svg": [
		8856,
		8856
	],
	"./other/Delete.svg": [
		28831,
		8831
	],
	"./other/Document.svg": [
		42664,
		2664
	],
	"./other/Edit.svg": [
		89129,
		9129
	],
	"./other/Email.svg": [
		81014,
		1014
	],
	"./other/Eye.svg": [
		8932,
		8932
	],
	"./other/EyeClosed.svg": [
		66175,
		6175
	],
	"./other/Goblet.svg": [
		66901,
		6901
	],
	"./other/Job.svg": [
		75630,
		5630
	],
	"./other/Key.svg": [
		12556,
		2556
	],
	"./other/Location.svg": [
		29820,
		9820
	],
	"./other/Lock.svg": [
		37930,
		7930
	],
	"./other/LogOut.svg": [
		43860,
		3860
	],
	"./other/Mail.svg": [
		15658,
		5658
	],
	"./other/MyNFT.svg": [
		15110,
		5110
	],
	"./other/People.svg": [
		12607,
		2607
	],
	"./other/Person.svg": [
		7618,
		7618
	],
	"./other/PersonWithEye.svg": [
		82937,
		2937
	],
	"./other/PersonalizationBicolor.svg": [
		83033,
		9318
	],
	"./other/Price.svg": [
		90013,
		13
	],
	"./other/Profile.svg": [
		52251,
		2251
	],
	"./other/Reward.svg": [
		43726,
		3726
	],
	"./other/RocketBicolor.svg": [
		94891,
		4891
	],
	"./other/Security.svg": [
		60071,
		71
	],
	"./other/Send.svg": [
		89539,
		9539
	],
	"./other/Settings.svg": [
		90866,
		866
	],
	"./other/Share.svg": [
		78359,
		8359
	],
	"./other/Shield.svg": [
		85450,
		5450
	],
	"./other/Shop.svg": [
		22454,
		4856
	],
	"./other/Sort.svg": [
		63865,
		3865
	],
	"./other/Speedometer.svg": [
		10190,
		190
	],
	"./other/Star.svg": [
		42771,
		2771
	],
	"./other/StarFourPointed.svg": [
		71912,
		1912
	],
	"./other/Stopwatch.svg": [
		30943,
		943
	],
	"./other/TextBicolor.svg": [
		55788,
		5788
	],
	"./other/UserWithEye.svg": [
		48871,
		8871
	],
	"./other/Wallet.svg": [
		48456,
		7322
	],
	"./other/WalletBicolor.svg": [
		6729,
		6729
	],
	"./player/BackwardFive.svg": [
		2126,
		2126
	],
	"./player/ForwardFive.svg": [
		85411,
		5411
	],
	"./player/Maximize.svg": [
		81390,
		1390
	],
	"./player/Minimize.svg": [
		40122,
		122
	],
	"./player/Pause.svg": [
		71385,
		1385
	],
	"./player/Play.svg": [
		80997,
		997
	],
	"./player/Volume.svg": [
		64745,
		4745
	],
	"./player/VolumeOff.svg": [
		17109,
		7109
	],
	"./socials/colorful/Discord.svg": [
		60615,
		615
	],
	"./socials/colorful/Facebook.svg": [
		44558,
		4558
	],
	"./socials/colorful/Google.svg": [
		92482,
		2482
	],
	"./socials/colorful/Linkedin.svg": [
		616,
		616
	],
	"./socials/colorful/LinkedinSquare.svg": [
		60155,
		155
	],
	"./socials/colorful/Metamask.svg": [
		73045,
		3045
	],
	"./socials/colorful/Telegram.svg": [
		6502,
		6502
	],
	"./socials/colorful/TelegramRounded.svg": [
		78571,
		8571
	],
	"./socials/colorful/Twitter.svg": [
		56470,
		6470
	],
	"./socials/colorful/Viber.svg": [
		28899,
		8899
	],
	"./socials/colorful/WalletConnect.svg": [
		374,
		374
	],
	"./socials/colorful/Whatsapp.svg": [
		81166,
		1166
	],
	"./socials/monochrome/Apple.svg": [
		11415,
		1415
	],
	"./socials/monochrome/Discord.svg": [
		11186,
		1186
	],
	"./socials/monochrome/Facebook.svg": [
		62341,
		2341
	],
	"./socials/monochrome/Instagram.svg": [
		13194,
		3194
	],
	"./socials/monochrome/LinkedIn.svg": [
		86510,
		6510
	],
	"./socials/monochrome/Twitter.svg": [
		50931,
		931
	],
	"./socials/monochrome/Youtube.svg": [
		95669,
		5669
	],
	"./system/arrow/ArrowDown.svg": [
		31155,
		1155
	],
	"./system/arrow/ArrowLeft.svg": [
		83667,
		3667
	],
	"./system/arrow/ArrowRight.svg": [
		95314,
		4390
	],
	"./system/arrow/ArrowUp.svg": [
		51093,
		1093
	],
	"./system/chevron/ChevronDown.svg": [
		22826,
		2826
	],
	"./system/chevron/ChevronLeft.svg": [
		55842,
		5842
	],
	"./system/chevron/ChevronRight.svg": [
		35297,
		5297
	],
	"./system/chevron/ChevronUp.svg": [
		66298,
		6298
	],
	"./system/other/Back.svg": [
		8877,
		8877
	],
	"./system/other/Check.svg": [
		57213,
		7213
	],
	"./system/other/Clear.svg": [
		83314,
		3314
	],
	"./system/other/Close.svg": [
		46888,
		6888
	],
	"./system/other/Copy.svg": [
		26892,
		6892
	],
	"./system/other/Danger.svg": [
		8713,
		8713
	],
	"./system/other/Info.svg": [
		93940,
		3940
	],
	"./system/other/MaximizeArrows.svg": [
		82766,
		2766
	],
	"./system/other/Menu.svg": [
		77438,
		7438
	],
	"./system/other/MenuMinimized.svg": [
		69349,
		9349
	],
	"./system/other/Minus.svg": [
		37929,
		7929
	],
	"./system/other/More.svg": [
		65439,
		5439
	],
	"./system/other/Pending.svg": [
		99446,
		9446
	],
	"./system/other/Placeholder.svg": [
		10721,
		721
	],
	"./system/other/Plus.svg": [
		2133,
		2133
	],
	"./system/other/Search.svg": [
		34069,
		4069
	],
	"./system/other/Success.svg": [
		86891,
		6891
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 73593;
module.exports = webpackAsyncContext;